import React from "react";
import { Tab, Nav } from "react-bootstrap";

import { faqsTabItem,faqsTabContent } from "../../data";
import FaqsTabItem from "./FaqsTabItem";
import TabAccordion from "./TabAccordion";
const FaqsTab = () => {
  return (
    <>
      <div className="faqs__tab">
        <Tab.Container defaultActiveKey="membership">
          <div className="faqs__filter">
            <Nav variant="pills" className="faqs__nav justify-content-center">
              {faqsTabItem.map((val, index) => {
                return (
                  <FaqsTabItem
                    key={index}
                    icon={val.icon}
                    title={val.title}
                    eventKey={val.eventKey}
                  />
                );
              })}
            </Nav>
          </div>
          <Tab.Content>
            {faqsTabContent.map((val, index) => {
              return (
                <Tab.Pane eventKey={val.eventKey} key={index}>
                  <h3>{val.title}</h3>
                  <TabAccordion data={val.details} />
                </Tab.Pane>
              );
            })}
          </Tab.Content>
        </Tab.Container>
      </div>
    </>
  );
};

export default FaqsTab;
